__turbopack_context__.v({
  "ant-layout-footer": "iJU88W_ant-layout-footer",
  "descriptionNL": "iJU88W_descriptionNL",
  "desription": "iJU88W_desription",
  "divider": "iJU88W_divider",
  "icons": "iJU88W_icons",
  "inputEmail": "iJU88W_inputEmail",
  "inputNL": "iJU88W_inputNL",
  "logo": "iJU88W_logo",
  "main-footer": "iJU88W_main-footer",
  "main-section": "iJU88W_main-section",
  "mainFooter": "iJU88W_mainFooter",
  "menus": "iJU88W_menus",
  "section-1": "iJU88W_section-1",
  "section-2": "iJU88W_section-2",
  "section-3": "iJU88W_section-3",
  "section-4": "iJU88W_section-4",
  "sectionSosmed": "iJU88W_sectionSosmed",
  "socmed-icon": "iJU88W_socmed-icon",
  "sosmed": "iJU88W_sosmed",
  "store": "iJU88W_store",
  "sub-section": "iJU88W_sub-section",
  "tagline": "iJU88W_tagline",
  "titleNL": "iJU88W_titleNL",
});
